<template>
    <div class="layout__padding-clear">
        <div class="text__align-center text__colour-teal layout__margin__bottom-25px colour__background__grey-f7f8fa">
            <div class="layout__padding-clear layout__padding-20px">
                <div class="text__colour-teal text__size-45 text__style-bold-700">Printed Products</div>
            </div>
        </div>

        <div class="layout__padding-clear layout__width-75">
            <div class="component__columns-2 layout__margin-20-0">
                <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/newhomecard.jpg" class="layout__width-90 layout__padding__bottom-25px">
            </div>
            <div class="component__columns-2 layout__margin-20-0">
                <div class="text__colour-teal text__size-45 text__style-bold-700 layout__padding__bottom-20">Cards and Invitations</div>
                <h3 class="text__colour-teal text__style-bold-900">Strengthen brand loyalty, build relationships and encourage referrals.</h3>

                <div class="text__size-16 text__colour-grey layout__padding-20-0 text__line-height-20px">
                    Choose a template, adapt a design to suit your brand, or instruct our design studio to create something unique, the choice is yours!
                </div>
                <div>
                    The products featured on this site are from our standard product range however we are happy to deal with bespoke requests, give our team a call to discuss your specific requirements.
                </div>

                <div class="layout__padding-20-0">
                    <el-button class="layout__width-200px button-red"
                               v-on:click="contactUs()">Contact us
                    </el-button>
                </div>
            </div>
        </div>

        <div class="layout__padding-20-0">
            <div class="layout__padding-clear layout__width-75 layout__padding-20-0">
                <GetAPrice v-bind:category="'Greetings Cards & Invitations'" v-bind:showOptionsBool="true"></GetAPrice>
            </div>
        </div>

        <div class="layout__padding-20px colour__background__grey-f7f8fa layout__padding-clear layout__overflow-hidden">
            <div class="text__size-30 text__align-center text__colour-teal text__style-bold-900 layout__padding-20px">
                You may also like
            </div>

            <div class="layout__width-80 layout__padding-clear">

                <router-link class="link__colour-black" to="/products/digital/web-banners">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/web-banner-720x500.png" class="layout__width-100">
                        <div class="component__product__card-small-subtitle-text">
                            <div>Web Banners</div>
                        </div>
                    </div>
                </router-link>

                <router-link class="link__colour-black" to="/products/digital/microsites">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/micrositemockup.jpg" class="layout__width-100">
                        <div class="component__product__card-small-subtitle-text">
                            <div>Microsites</div>
                        </div>
                    </div>
                </router-link>

                <router-link class="link__colour-black" to="/products/digital/animated-brochure">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/animated-brochure-720x500.png" class="layout__width-100">
                        <div class="component__product__card-small-subtitle-text">
                            <div>Animated Brochure</div>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>


    </div>

</template>

<script>

    import GetAPrice from '../../../components/productServices/print/GetAPrice.vue';
    import Router from '../../../router';

    export default {
        name: "SM",
        components: {
            GetAPrice
        },
        data() {
            return {}
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            }
        }
    };
</script>